import { TFormattedMoney } from "@sembark-travel/money"
import { ITrip } from "../Trips"
import { useXHR } from "@sembark-travel/xhr"
import useSWR from "swr"
import { queryToSearch } from "@sembark-travel/ui/router"

export type TTripSalesReport = ITrip & {
	is_canceled_between_duration: boolean
	is_converted_between_duration: boolean
	revenue_in_given_currency: TFormattedMoney
	tax_in_cost_currency: TFormattedMoney | null
	flights_included?: boolean
	profit_in_cost_currency: TFormattedMoney | null
	profit_percentage: number | null
	null_profit_reason: string
}

export type TTripSalesReportByType = {
	id: number
	name: string
	deleted_at?: string | null
	total_conversion: number
	total_dropped: number
	total_pax: number
	total_queries: number
	total_quotes: number
	total_amount: Array<TFormattedMoney>
	total_profit: Array<TFormattedMoney> | null
	profit_percentage: number | null
	conversion_percentage?: number | null
	average_quotes?: number | null
}

export type TStats = {
	total_amount: Array<TFormattedMoney>
	total_conversion: number
	total_dropped: number
	total_queries: number
	total_quotes: number
}

export function useTripSalesReportStats({
	params,
}: {
	params: Record<string, unknown>
}) {
	const xhr = useXHR()
	const { page, ...otherParams } = params
	const { data: stats, error } = useSWR(
		`/trip-sales-reports-stats?${queryToSearch(otherParams)}`,
		() =>
			xhr
				.get<{ data: TStats }>("/trip-sales-reports/stats", {
					params: {
						...params,
					},
				})
				.then((resp) => resp.data.data)
	)
	return { stats, error }
}
